import { _get, _set, toArray } from './utils/ObjectUtils';

/**
 * Description:
 *  UmiLogger is a tool for developers. 
 *  It's used for debugging some applications.
 * 
 * Setup:
 *  umicoreDebugger = new UmiLogger('myApp');
 */
class UmiLogger {

  constructor(name) {
    this.name = name;
    this.logs = {};
    if (
      !('log' in console &&
      'group' in console &&
      'groupCollapsed' in console &&
      'groupEnd' in console)
    ) {
      this.append = new Function;
    }
  }

  /**
   * Example: 
   *  umicoreDebugger.append('Logging something', 'umicore.something', 'warn')
   * @param {String} level - log | warn | error | debug
   */
  append(log, path, level) {
    const newLog = [
      ..._get(this.logs, path, []), // Previous logs or [] if no logs
      { log, level } // New log
    ];
    _set(this.logs, path, newLog);
    return this;
  }
  
  /**
   * Prints all logs
   */
  report() {
    console.groupCollapsed(`[${this.name}]: Logger Report Details`);
    this.breakDown(this.logs);
    console.groupEnd();
  }

  /**
   * breakDown
   * @param {Array|Object} section 
   */
  breakDown(section) {
    for (let key in section) {
      if (!section.hasOwnProperty(key)) 
        continue;
      let _section = section[key];
      if (_section instanceof Array) { // Ready to log
        this.print(_section, key);
      } else if (typeof _section === 'object') { // Needs breakdown
        this.breakDown(_section);
      }
    }
  }

  /**
   * print
   * @param {Array} page 
   * @param {String} title 
   */
  print(page, title) {
    console.group(title);
    for (let i = 0; i < page.length; i++) {
      console[page[i].level || 'log'].apply(null, toArray(page[i].log));
    }
    console.groupEnd();
  }

}

export default UmiLogger;


// WEBPACK FOOTER //
// ../UmiCore/src/UmiLogger.js